/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createPrint } from '../../factoriesAny.js';
export var printDependencies = {
  typedDependencies,
  createPrint
};